/**
 * Soul Light Germany
 * Dark-Mode-Bridge für Socialwidget Instafeed
 *
 * Light Mode:
 * Die im Socialwidget-Editor eingestellten Farben bleiben erhalten.
 *
 * Dark Mode:
 * Nur die konkret betroffenen Profiltexte und Buttons werden angepasst.
 */

(function () {
  'use strict';

  if (window.__SLG_SOCIALWIDGET_THEME_V2__) return;
  window.__SLG_SOCIALWIDGET_THEME_V2__ = true;

  var ORIGINAL_STYLE_ATTRIBUTE =
    'data-slg-socialwidget-original-style';

  var updateQueued = false;

  function isDarkMode() {
    return (
      document.documentElement.getAttribute('data-theme') ===
      'dark'
    );
  }

  function rememberOriginalStyle(element) {
    if (!element || !element.hasAttribute) return;

    if (
      element.hasAttribute(ORIGINAL_STYLE_ATTRIBUTE)
    ) {
      return;
    }

    var originalStyle =
      element.getAttribute('style');

    element.setAttribute(
      ORIGINAL_STYLE_ATTRIBUTE,
      originalStyle === null ? '' : originalStyle
    );
  }

  function restoreOriginalStyle(element) {
    if (!element || !element.hasAttribute) return;

    if (
      !element.hasAttribute(ORIGINAL_STYLE_ATTRIBUTE)
    ) {
      return;
    }

    var originalStyle =
      element.getAttribute(ORIGINAL_STYLE_ATTRIBUTE);

    if (originalStyle) {
      element.setAttribute('style', originalStyle);
    } else {
      element.removeAttribute('style');
    }

    element.removeAttribute(
      ORIGINAL_STYLE_ATTRIBUTE
    );
  }

  function setImportant(element, property, value) {
    if (!element || !element.style) return;

    rememberOriginalStyle(element);

    element.style.setProperty(
      property,
      value,
      'important'
    );
  }

  function findWidgetRoots() {
    var roots = [];

    document
      .querySelectorAll(
        [
          '.socialwidget',
          '[class*="socialwidget" i]',
          '[class*="social-widget" i]',
          '[id*="socialwidget" i]',
          '.sw-instagram-container',
          '.sw-instagram-wrapper'
        ].join(',')
      )
      .forEach(function (root) {
        if (roots.indexOf(root) === -1) {
          roots.push(root);
        }
      });

    return roots;
  }

  function queryAllWithinRoots(selector) {
    var elements = [];

    findWidgetRoots().forEach(function (root) {
      if (root.matches && root.matches(selector)) {
        elements.push(root);
      }

      root
        .querySelectorAll(selector)
        .forEach(function (element) {
          if (elements.indexOf(element) === -1) {
            elements.push(element);
          }
        });
    });

    return elements;
  }

  function restoreLightMode() {
    document
      .querySelectorAll(
        '[' +
          ORIGINAL_STYLE_ATTRIBUTE +
          ']'
      )
      .forEach(restoreOriginalStyle);
  }

  function styleText(element, color) {
    setImportant(element, 'color', color);
    setImportant(
      element,
      '-webkit-text-fill-color',
      color
    );
    setImportant(element, 'opacity', '1');
    setImportant(element, 'visibility', 'visible');
  }

  function styleButtonContainer(
    element,
    background,
    foreground,
    borderColor
  ) {
    if (!element) return;

    setImportant(
      element,
      'background',
      background
    );
    setImportant(
      element,
      'background-color',
      background
    );
    setImportant(
      element,
      'background-image',
      'none'
    );

    setImportant(
      element,
      'color',
      foreground
    );
    setImportant(
      element,
      '-webkit-text-fill-color',
      foreground
    );

    setImportant(
      element,
      'border-color',
      borderColor
    );
    setImportant(
      element,
      'opacity',
      '1'
    );
    setImportant(
      element,
      'visibility',
      'visible'
    );

    element
      .querySelectorAll('*')
      .forEach(function (child) {
        styleText(child, foreground);
      });
  }

  function applyDarkMode() {
    var primaryText = '#f3efe8';
    var secondaryText =
      'rgba(245, 243, 238, 0.74)';

    /*
      Profilname
    */
    queryAllWithinRoots(
      '.sw-instagram-header-instagram-block-username'
    ).forEach(function (element) {
      styleText(element, primaryText);
    });

    /*
      Beitragszahlen und Beschriftungen
    */
    queryAllWithinRoots(
      '.sw-instagram-header-instagram-block-item-count'
    ).forEach(function (element) {
      styleText(element, secondaryText);
    });

    queryAllWithinRoots(
      [
        '.sw-instagram-header-instagram-block-item-count-post',
        '.sw-instagram-header-instagram-block-item-count-followers',
        '.sw-instagram-header-instagram-block-item-count-following'
      ].join(',')
    ).forEach(function (element) {
      styleText(element, primaryText);
    });

    /*
      Biografie
    */
    queryAllWithinRoots(
      '.sw-instagram-header-instagram-block-biography'
    ).forEach(function (element) {
      styleText(element, secondaryText);
    });

    /*
      Folgen-Button:
      Der eigentliche Hintergrund sitzt im inneren div.
    */
    queryAllWithinRoots(
      '.sw-instagram-header-instagram-block-follow a'
    ).forEach(function (element) {
      styleButtonContainer(
        element,
        'transparent',
        '#171614',
        'transparent'
      );

      setImportant(
        element,
        'box-shadow',
        'none'
      );
    });

    queryAllWithinRoots(
      '.sw-instagram-header-instagram-block-follow a > div'
    ).forEach(function (element) {
      styleButtonContainer(
        element,
        '#f3efe8',
        '#171614',
        'rgba(245, 243, 238, 0.42)'
      );

      setImportant(
        element,
        'border-radius',
        '999px'
      );
      setImportant(
        element,
        'box-shadow',
        '0 5px 16px rgba(0, 0, 0, 0.24)'
      );
    });

    /*
      Weitere Beiträge:
      Auch hier sitzt das sichtbare Buttondesign
      auf dem inneren div.
    */
    queryAllWithinRoots(
      '.sw-instagram-footer-load-more'
    ).forEach(function (element) {
      setImportant(
        element,
        'color',
        primaryText
      );
      setImportant(
        element,
        '-webkit-text-fill-color',
        primaryText
      );
    });

    queryAllWithinRoots(
      '.sw-instagram-footer-load-more > div'
    ).forEach(function (element) {
      styleButtonContainer(
        element,
        'transparent',
        primaryText,
        'rgba(245, 243, 238, 0.42)'
      );

      setImportant(
        element,
        'border',
        '1px solid rgba(245, 243, 238, 0.42)'
      );
      setImportant(
        element,
        'border-radius',
        '999px'
      );
      setImportant(
        element,
        'box-shadow',
        'none'
      );
    });
  }

  function applyLightMode() {
  /*
    Weitere-Beiträge-Button im Light Mode:
    dunkler Hintergrund, helle Schrift.
  */
  queryAllWithinRoots(
    '.sw-instagram-footer-load-more'
  ).forEach(function (element) {
    styleText(element, '#ffffff');
  });

  queryAllWithinRoots(
    '.sw-instagram-footer-load-more > div'
  ).forEach(function (element) {
    styleButtonContainer(
      element,
      '#1d1b18',
      '#ffffff',
      '#1d1b18'
    );

    setImportant(
      element,
      'border',
      '1px solid #1d1b18'
    );

    setImportant(
      element,
      'border-radius',
      '999px'
    );

    setImportant(
      element,
      'box-shadow',
      'none'
    );
  });
}

  function applyTheme() {
    if (isDarkMode()) {
      applyDarkMode();
    } else {
      restoreLightMode();
    }
  }

  function scheduleUpdate() {
    if (updateQueued) return;

    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      applyTheme();
    });
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(
      scheduleUpdate
    );

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener(
    'slg-theme-change',
    scheduleUpdate
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleUpdate,
      { once: true }
    );
  } else {
    scheduleUpdate();
  }

  window.addEventListener(
    'load',
    scheduleUpdate
  );

  [300, 900, 1800, 3500].forEach(
    function (delay) {
      window.setTimeout(
        scheduleUpdate,
        delay
      );
    }
  );
})();